<template>
  <div class="main">
    <div class="main-left">
      <div class="img-top">
        <img :src="rewardsChildData.imgurl" alt="图片" />
        <div>{{ rewardsChildData.name }}</div>
      </div>
      <div class="boxs-bottom">
        <div class="boxs" v-for="(item,index) in boxsList" :key="index">
          <span class="dollar">$</span>
          <span class="number">{{ item.number }}</span>
        </div>
      </div>
    </div>
    <div class="main-right">
      <div class="title">{{ rewardsChildData.title }}</div>
      <p v-for="(item, index) in rewardsChildData.pList" :key="index">
        {{ item }}
      </p>
      <div class="explain">{{ rewardsChildData.explain }}</div>
      <div class="get-rewards" @click="exchange">इनाम प्राप्त करें</div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["rewardsChildData"],
  data() {
    return {
      boxsList: [],
    };
  },
  methods: {
    exchange() {
      this.$emit("exchange");
    },
  },
  created() {
    this.boxsList.push(this.rewardsChildData)
  },
};
</script>
<style scoped>
.main {
  display: flex;
  margin-top: 10px;
}
.main-left {
  width: 173.125px;
}
.main-right {
  width: calc(100% - 30px);
  padding-left: 30px;
}
.img-top > img {
  width: 100%;
}
.img-top > div {
  font-size: 15.625px;
  margin-top: 12.5px;
  font-weight: bold;
  text-align: center;
}
.boxs-bottom {
  display: flex;
  flex-direction: column;
  margin-top: 21.875px;
}
.boxs {
  width: calc(100% - 23.125px);
  height: 37.5px;
  background: #f7f8fa;
  border-radius: 2.5px;
  border: 0.625px solid #dddddd;
  margin-bottom: 2.5px;
  padding-left: 21.875px;
  font-weight: bold;
  display: flex;
  align-items: center;
}
.boxs .dollar {
  font-size: 12.5px;
}
.boxs .number {
  margin-left: 5px;
  font-size: 16px;
}
.main-right .title {
  font-size: 10px;
  font-weight: bold;
  margin-bottom: 18px;
}
.main-right p {
  width: 412.5px;
  font-size: 8.75px;
  margin-bottom: 23px;
  line-height: 15px;
}
.explain {
  width: 412.5px;
  font-size: 10px;
  font-weight: bold;
  margin-bottom: 18px;
}
.get-rewards {
  width: 101.875px;
  height: 22.5px;
  background: #2e67ea;
  border-radius: 2.5;
  color: #ffffff;
  font-size: 10px;
  text-align: center;
  line-height: 22.5px;
  cursor: pointer;
  margin-top: 40px;
}
</style>
<style scoped>
@media only screen and (max-width: 1000px) {
  .main {
    width: 100%;
    padding: 0;
    flex-direction: column;
  }
  .main-left {
    width: 100%;
    display: flex;
    margin-bottom: 30px;
  }
  .main-left .img-top {
    width: 400px;
  }
  .boxs-bottom {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
    width: 100%;
    margin: 0;
    padding-left: 20px;
  }
  .boxs {
    width: 120px;
  }
  .main-right {
    padding: 0;
    width: 100%;
  }
  .main-right p {
    width: 100%;
  }
  .explain {
    width: 100%;
  }
  .get-rewards {
    float: right;
  }
}
@media only screen and (max-width: 950px) {
  .main-left .img-top {
    width: 350px;
  }
}
@media only screen and (max-width: 920px) {
  .boxs {
    width: 100px;
  }
}
@media only screen and (max-width: 820px) {
  .boxs {
    width: 80px;
  }
}
@media only screen and (max-width: 750px) {
  .boxs {
    width: 60px;
    padding: 0;
 display: flex;
 justify-content: center;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/mycom/rewardsChild.vue